module.exports = __webpack_public_path__ + "static/img/MN.feb212ae.svg";